export default __webpack_public_path__ + "static/media/play2.66c721b9.svg";